"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7062],{

/***/ 61771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_counter_IdeaCounter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32306);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3620);
/* harmony import */ var utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23244);









var BaseSourceTitle = function(_param) {
    var leftItem = _param.leftItem, mainTitle = _param.mainTitle, subTitle = _param.subTitle, _size = _param.size, size = _size === void 0 ? "lg" : _size, titleHeadingSize = _param.titleHeadingSize, noOfLines = _param.noOfLines, source = _param.source, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "leftItem",
        "mainTitle",
        "subTitle",
        "size",
        "titleHeadingSize",
        "noOfLines",
        "source"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        switch(size){
            case "sm":
                {
                    return {
                        headingTextSize: {
                            textSize: "s",
                            fontSize: "1rem",
                            lineHeight: "1.25rem"
                        },
                        titleMarginTop: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(1),
                        titleMarginLeft: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(12)
                    };
                }
            case "md":
                {
                    return {
                        headingTextSize: {
                            textSize: "s",
                            fontWeight: 800
                        },
                        titleMarginTop: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(0),
                        titleMarginLeft: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16)
                    };
                }
            default:
                {
                    return {
                        headingTextSize: {
                            textSize: isMobileView ? "s" : "m"
                        },
                        titleMarginTop: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                        titleMarginLeft: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16)
                    };
                }
        }
    }, [
        isMobileView,
        size
    ]), headingTextSize = ref.headingTextSize, titleMarginTop = ref.titleMarginTop, titleMarginLeft = ref.titleMarginLeft;
    var showPlaceholder = mainTitle === "";
    var _alignItems, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        mb: {
            base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
            lg: "unset"
        },
        mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
        w: isMobileView ? "calc(100% - 1rem)" : "100%",
        mx: "0.5rem",
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem
    }, props), {
        children: [
            leftItem,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                flexDir: "column",
                mt: titleMarginTop,
                justifyContent: "center",
                ml: leftItem ? titleMarginLeft : 0,
                alignItems: (_alignItems = props.alignItems) !== null && _alignItems !== void 0 ? _alignItems : "flex-start",
                w: "100%",
                textAlign: props.textAlign,
                zIndex: 1,
                children: [
                    titleHeadingSize === "p" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, headingTextSize), {
                        fontWeight: 700,
                        lineHeight: "1.255em",
                        color: showPlaceholder ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textDisabled : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                        noOfLines: noOfLines,
                        zIndex: 1,
                        w: "100%",
                        wordBreak: "break-word",
                        mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
                        children: showPlaceholder ? utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z[types__WEBPACK_IMPORTED_MODULE_4__/* .ADD_SOURCE */ .fu].addTitle : mainTitle
                    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.SecondaryHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, headingTextSize), {
                        fontWeight: 700,
                        lineHeight: "1.255em",
                        color: showPlaceholder ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textDisabled : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                        noOfLines: noOfLines,
                        zIndex: 1,
                        w: "100%",
                        size: titleHeadingSize,
                        wordBreak: "break-word",
                        mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
                        children: showPlaceholder ? utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z[types__WEBPACK_IMPORTED_MODULE_4__/* .ADD_SOURCE */ .fu].addTitle : mainTitle
                    })),
                    subTitle,
                    ((ref2 = (ref1 = source === null || source === void 0 ? void 0 : source.ideaCount) !== null && ref1 !== void 0 ? ref1 : source === null || source === void 0 ? void 0 : source.ideas.length) !== null && ref2 !== void 0 ? ref2 : 0) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_counter_IdeaCounter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        ideaCount: (ref4 = (ref3 = source === null || source === void 0 ? void 0 : source.ideaCount) !== null && ref3 !== void 0 ? ref3 : source === null || source === void 0 ? void 0 : source.ideas.length) !== null && ref4 !== void 0 ? ref4 : 0,
                        totalReadCount: (source === null || source === void 0 ? void 0 : source.status) === types__WEBPACK_IMPORTED_MODULE_4__/* .ArticleStatus.PUBLISHED */ .af.PUBLISHED ? source === null || source === void 0 ? void 0 : source.totalReads : undefined,
                        mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseSourceTitle);


/***/ }),

/***/ 83805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ InfoLinkWrapper; }
/* harmony export */ });
/* unused harmony export getLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50752);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var hooks_useLocation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8022);
/* harmony import */ var src_providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79139);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);








var getLink = function(source) {
    return "/article/".concat(source.id, "/").concat((0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(source.title));
};
var getCollectionSourceLink = function(param) {
    var source = param.source, collectionId = param.collectionId;
    return "/article/".concat(source.id, "/").concat((0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(source.title), "?collection=").concat(collectionId);
};
var InfoLinkWrapper = function(param) {
    var children = param.children, source = param.source, withLink = param.withLink, isNotInteractable = param.isNotInteractable;
    var location = (0,hooks_useLocation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var isLoggedIn = (0,src_providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().isLoggedIn;
    // if we are on the article or add-source pages, don't wrap in a NextLink
    //If withLink is true, it would override the regex match
    if (location.match(/article|studio/g) && !withLink || isNotInteractable) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    var link = getLink(source);
    if (location.match(/collection/) && isLoggedIn) {
        var ref;
        var ref1;
        link = getCollectionSourceLink({
            source: source,
            collectionId: (ref1 = (ref = router.asPath.split("/")) === null || ref === void 0 ? void 0 : ref[2]) !== null && ref1 !== void 0 ? ref1 : "0"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: link,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            href: link,
            onClick: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .onLinkClick */ .nt,
            _focus: undefined,
            _hover: undefined,
            _active: undefined,
            isExternal: false,
            width: "100%",
            title: source.title,
            children: children
        })
    });
};


/***/ }),

/***/ 53859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var SourceDomain = function(param) {
    var domain = param.domain, size = param.size, _hasExternalSvg = param.hasExternalSvg, hasExternalSvg = _hasExternalSvg === void 0 ? true : _hasExternalSvg, isNotInteractable = param.isNotInteractable;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        alignItems: "center",
        children: [
            domain && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                size: size === "sm" ? "xs" : "s",
                _hover: hasExternalSvg && !isNotInteractable ? {
                    textDecoration: "underline",
                    cursor: "pointer"
                } : undefined,
                noOfLines: 1,
                overflowWrap: "anywhere",
                children: domain
            }),
            hasExternalSvg && domain && !isNotInteractable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.ExternalSvg, {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                boxSize: size === "sm" ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                minWidth: size === "sm" ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceDomain);


/***/ }),

/***/ 17062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var types_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41390);
/* harmony import */ var _InfoLinkWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83805);
/* harmony import */ var _BaseSourceTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61771);
/* harmony import */ var _SourceDomain__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53859);
/* harmony import */ var _source_image_SourceImageV2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53098);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14531);












var SourcePodcastTitle = function(_param) {
    var source = _param.source, noOfLines = _param.noOfLines, titleHeadingSize = _param.titleHeadingSize, withLink = _param.withLink, _showPlayer = _param.showPlayer, showPlayer = _showPlayer === void 0 ? true : _showPlayer, size = _param.size, isNotInteractable = _param.isNotInteractable, preload = _param.preload, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "source",
        "noOfLines",
        "titleHeadingSize",
        "withLink",
        "showPlayer",
        "size",
        "isNotInteractable",
        "preload"
    ]);
    var ref;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var ref1, ref2, ref3;
    var subTitle = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return isNotInteractable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
            zIndex: 1,
            children: [
                source.sourceSubtype === types_enums__WEBPACK_IMPORTED_MODULE_3__/* .SourceSubtype.PODCAST_SPOTIFY */ .eL.PODCAST_SPOTIFY && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.SpotifySvg, {
                    boxSize: size === "sm" ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.L.rem,
                    color: "#1DB954",
                    mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                    zIndex: 1
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SourceDomain__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    domain: (ref1 = source === null || source === void 0 ? void 0 : source.author) !== null && ref1 !== void 0 ? ref1 : "",
                    size: size,
                    isNotInteractable: isNotInteractable
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            href: (ref2 = source === null || source === void 0 ? void 0 : source.url) !== null && ref2 !== void 0 ? ref2 : "",
            _focus: undefined,
            _hover: {
                textDecoration: "underline"
            },
            _active: undefined,
            isExternal: true,
            onClick: function(e) {
                return e.stopPropagation();
            },
            // For security reasons, we must add these:
            rel: "noopener nofollow noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                alignItems: "center",
                justifyContent: "flex-start",
                width: "100%",
                zIndex: 1,
                children: [
                    source.sourceSubtype === types_enums__WEBPACK_IMPORTED_MODULE_3__/* .SourceSubtype.PODCAST_SPOTIFY */ .eL.PODCAST_SPOTIFY && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.SpotifySvg, {
                        boxSize: size === "sm" ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.L.rem,
                        color: "#1DB954",
                        mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                        zIndex: 1
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SourceDomain__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        domain: (ref3 = source === null || source === void 0 ? void 0 : source.author) !== null && ref3 !== void 0 ? ref3 : "",
                        size: size
                    })
                ]
            })
        });
    }, [
        size,
        source,
        isNotInteractable
    ]);
    var leftItem = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_source_image_SourceImageV2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            source: source,
            size: isMobileView ? utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .SOURCE_COLLAPSED_LARGE_IMAGE_SIZE_MOBILE */ .kc : utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .SOURCE_COLLAPSED_LARGE_IMAGE_SIZE_DESKTOP */ .Mu,
            isNotInteractable: isNotInteractable,
            preload: preload
        });
    }, [
        size,
        source,
        isNotInteractable,
        isMobileView
    ]);
    var showPlayerCondition = showPlayer && source.status === types_enums__WEBPACK_IMPORTED_MODULE_3__/* .ArticleStatus.DRAFT */ .af.DRAFT && source.sourceSubtype === types_enums__WEBPACK_IMPORTED_MODULE_3__/* .SourceSubtype.PODCAST_SPOTIFY */ .eL.PODCAST_SPOTIFY;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Grid, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        alignItems: "center"
    }, props), {
        w: "90%",
        justifyContent: "flex-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InfoLinkWrapper__WEBPACK_IMPORTED_MODULE_4__/* .InfoLinkWrapper */ .s, {
                source: source,
                withLink: withLink,
                isNotInteractable: isNotInteractable,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseSourceTitle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                    mainTitle: source.title,
                    leftItem: leftItem,
                    subTitle: subTitle,
                    size: size,
                    source: source,
                    titleHeadingSize: titleHeadingSize,
                    noOfLines: noOfLines
                }, props))
            }),
            showPlayerCondition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                width: "100%",
                mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                pr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem,
                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(240),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                    // Get the embeded version
                    src: (ref = source.url) === null || ref === void 0 ? void 0 : ref.replace("spotify.com", "spotify.com/embed-podcast"),
                    width: "100%",
                    height: "100%",
                    allowTransparency: true,
                    allow: "encrypted-media"
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SourcePodcastTitle);


/***/ })

}]);